import React, { Suspense, lazy } from "react"
import Cookies from "universal-cookie"
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom"

import { HttpProvider } from "../services/httpProvider"
import Progress from "../Components/uiComponents/Progress"

const MedicalQuestionnaire = lazy(() =>
  import("../Components/MedicalQuestionnaire")
)
const Checkout = lazy(() => import("../Components/Checkout"))
const Login = lazy(() => import("../Components/Administrative/Steps/Login"))
const NotFound = lazy(() => import("../Components/Administrative/Steps/404"))
const ResetPassword = lazy(() =>
  import("../Components/Administrative/Steps/ResetPassword/ResetPassword")
)
const ActivateAccount = lazy(() =>
  import("../Components/Administrative/Steps/ActivateAccount/ActivateAccount")
)
const MailSent = lazy(() =>
  import("../Components/Administrative/Steps/ResetPassword/MailSent")
)
const SetPassword = lazy(() =>
  import("../Components/Administrative/Steps/ResetPassword/SetPassword")
)
const Referal = lazy(() =>
  import("../Components/Administrative/Steps/Referral")
)
const Dashboard = lazy(() =>
  import("../Components/Administrative/Steps/UserDashboard/Dashboard")
)
const Impressum = lazy(() =>
  import("../Components/Administrative/Terms/Impressum")
)
const AGB = lazy(() => import("../Components/Administrative/Terms/AGB"))
const Datenschutz = lazy(() =>
  import("../Components/Administrative/Terms/Datenschutz")
)
const DFApp = lazy(() => import("../Components/Administrative/Terms/DFApp"))
const Password = lazy(() =>
  import("../Components/Administrative/Steps/Password")
)
const TribeLogin = lazy(() =>
  import("../Components/Administrative/Steps/TribeLogin")
)
const CreateProfile = lazy(() =>
  import("../Components/Administrative/Steps/CreateProfile")
)

const getUrlParameter = function getUrlParameter(sParam) {
  let sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=")
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1])
    }
  }
  return false
}

const Routes = () => {
  const cookies = new Cookies()
  const [token, setToken] = React.useState(cookies.get("isLoggedIn"))
  const [refreshToken, setRefreshToken] = React.useState(
    cookies.get("refresh_token")
  )
  const [progress, setProgress] = React.useState(false)
  const [refreshCalled, setRefreshCalled] = React.useState(false)

  const refreshTheToken = async () => {
    try {
      setRefreshCalled(true)
      setProgress(true)
      const service = HttpProvider.getInstance()
      const res = await service.refreshToken()
      if (res) {
        setToken(res.data.token)
        setRefreshCalled(res.data.refresh_token)
        cookies.set("token", res.data.token, {
          path: "/",
          maxAge: 3600,
          domain: process.env.REACT_APP_DOMAIN,
        })
        cookies.set("refresh_token", res.data.refresh_token, {
          path: "/",
          domain: process.env.REACT_APP_DOMAIN,
        })
        cookies.set("isLoggedIn", true, {
          path: "/",
          domain: process.env.REACT_APP_DOMAIN,
          maxAge: 3600,
        })
        setRefreshCalled(false)
        setProgress(false)
      }
    } catch (err) {
      setProgress(false)
    }
  }

  React.useEffect(() => {
    if (
      !cookies.get(["token"]) &&
      cookies.get(["refresh_token"]) &&
      !refreshCalled
    ) {
      refreshTheToken()
    }
  }, [cookies])

  function handleRouteChange(before, after) {
    const data = window.dataLayer || []
    data.push({ event: "gatsby-route-change" })
  }

  return progress ? (
    <Progress />
  ) : (
    <Router>
      <Suspense fallback={<Progress />}>
        <Switch>
          <Route
            onChange={handleRouteChange}
            exact={true}
            path="/login"
            render={() =>
              token !== undefined && refreshToken !== undefined ? (
                <Redirect
                  to={`/dashboard${
                    getUrlParameter("redirect") === "candida" ||
                    getUrlParameter("redirect") === "relief"
                      ? "?redirect=" + getUrlParameter("redirect")
                      : ""
                  }`}
                />
              ) : (
                <Login
                  setToken={setToken}
                  setRefreshToken={setRefreshToken}
                  setProgress={setProgress}
                />
              )
            }
          />

          <Route
            exact={true}
            path="/resetpassword"
            component={ResetPassword}
            onChange={handleRouteChange}
          />
          <Route
            exact={true}
            path="/activateaccount"
            component={ActivateAccount}
            onChange={handleRouteChange}
          />
          <Route
            exact={true}
            path="/setpassword"
            component={SetPassword}
            onChange={handleRouteChange}
          />
          <Route
            exact={true}
            path="/mailsent"
            component={MailSent}
            onChange={handleRouteChange}
          />
          <Route
            exact={true}
            path="/referal"
            component={Referal}
            onChange={handleRouteChange}
          />

          <Route
            exact={true}
            path="/impressum"
            component={Impressum}
            onChange={handleRouteChange}
          />
          <Route
            exact={true}
            path="/agb"
            component={AGB}
            onChange={handleRouteChange}
          />
          <Route
            exact={true}
            path="/datenschutz"
            component={Datenschutz}
            onChange={handleRouteChange}
          />
          <Route
            exact={true}
            path="/datenschutz-fur-app"
            component={DFApp}
            onChange={handleRouteChange}
          />
          <Route
            exact={true}
            path="/password"
            component={Password}
            onChange={handleRouteChange}
          />
          {/* <Route exact={true} path="/tribelogin" component={TribeLogin} /> */}
          <Route
            onChange={handleRouteChange}
            exact={true}
            path="/tribelogin"
            render={() =>
              token !== undefined && refreshToken !== undefined ? (
                <TribeLogin />
              ) : (
                <Redirect to="/login" />
              )
            }
          />
          <Route
            onChange={handleRouteChange}
            exact={true}
            path="/"
            render={() =>
              token !== undefined && refreshToken !== undefined ? (
                <Redirect
                  to={`/dashboard${
                    getUrlParameter("redirect") === "candida" ||
                    getUrlParameter("redirect") === "relief"
                      ? "?redirect=" + getUrlParameter("redirect")
                      : ""
                  }`}
                />
              ) : (
                <Redirect to="/login" />
              )
            }
          />
          <Route
            onChange={handleRouteChange}
            exact={true}
            path="/dashboard"
            render={() =>
              token !== undefined && refreshToken !== undefined ? (
                cookies.get("redirectMedq") === "true" ? (
                  <Redirect to="/medq?type=redirectmedq" />
                ) : (
                  <Dashboard />
                )
              ) : (
                <Redirect to="/login" />
              )
            }
          />
          <Route
            exact={true}
            path="/medq"
            component={MedicalQuestionnaire}
            onChange={handleRouteChange}
          />
          <Route
            onChange={handleRouteChange}
            exact={true}
            path="/checkout"
            render={() =>
              cookies.get("token") !== undefined ? (
                <Checkout />
              ) : (
                <Redirect to="/medq" />
              )
            }
          />
          <Route
            exact={true}
            path="/profilecreated"
            component={CreateProfile}
            onChange={handleRouteChange}
          />
          <Route component={NotFound} onChange={handleRouteChange} />
          <Route
            exact={true}
            path="/impressum"
            component={Impressum}
            onChange={handleRouteChange}
          />
        </Switch>
      </Suspense>
    </Router>
  )
}

export default Routes
